import { createContext, useContext, useState, ReactNode, useCallback } from 'react';

export type DataSource = 'v1' | 'v2';

interface DataSourceContextType {
  dataSource: DataSource;
  toggleDataSource: () => void;
}

const DataSourceContext = createContext<DataSourceContextType | undefined>(undefined);

interface DataSourceProviderProps {
  children: ReactNode;
}

export function DataSourceProvider({ children }: DataSourceProviderProps) {
  const [dataSource, setDataSource] = useState<DataSource>('v2');

  const toggleDataSource = useCallback(() => {
    setDataSource(prev => {
      const next = prev === 'v1' ? 'v2' : 'v1';
      if (import.meta.env.DEV) console.log(`🔄 Switching data source from ${prev} to ${next}`);
      return next;
    });
  }, []);

  return (
    <DataSourceContext.Provider value={{ dataSource, toggleDataSource }}>
      {children}
    </DataSourceContext.Provider>
  );
}

export function useDataSource() {
  const context = useContext(DataSourceContext);
  if (context === undefined) {
    throw new Error('useDataSource must be used within a DataSourceProvider');
  }
  return context;
} 